import React, { createRef, useCallback, useMemo } from "react";
import { Formik } from "formik";
import { Button, FormikInput, SelectInput } from "presentation/common";
import clsx from "clsx";

import styles from "./styles.module.scss";
import { useSignDocuments } from "application/use-sign-documents";

export const PinForm = ({ docs = [], showErrorMessage }) => {
  const formRef = createRef();
  const { userInfo } = useSignDocuments();

  const documents = useMemo(() => {
    return [...docs.map((doc) => ({ ...doc, value: doc.id, label: doc.name }))];
  }, [docs]);

  const isUrl = (s) => {
    try {
      return Boolean(new URL(s));
    } catch (e) {
      showErrorMessage();
      return false;
    }
  };

  const SingIn = useCallback(() => {
    const doc = formRef.current?.values?.docs;
    if (doc.signatory_url.length > 0) {
      const _uri = doc.signatory_url.find(
        (d) => d.signatory_rut === userInfo.rut
      );
      if (isUrl(_uri.signatory_url)) {
        window.location.replace(_uri.signatory_url);
      }
    } else {
      showErrorMessage();
    }
  }, []);

  const onChangeSelection = useCallback((option) => {
    formRef.current?.setFieldValue("docs", option);
  }, []);

  return (
    <div className="flex flex-col w-full">
      <div className="hidden lg:block bg-gray-50 p-4 flex justify-between items-center uppercase">
        Datos Generales
      </div>

      <Formik
        innerRef={formRef}
        initialValues={{
          docs: null,
          pin: "",
        }}
        enableReinitialize
        onSubmit={() => {}}
      >
        {(formik) => {
          return (
            <div>
              <div
                className={clsx(
                  "grid grid-cols-1 lg:grid-cols-2 gap-4  mt-0 lg:mt-4 lg:grid-cols-1"
                )}
              >
                <FormikInput
                  required
                  Component={SelectInput}
                  name="docs"
                  label="Documentos a firmar"
                  options={documents}
                  onSelect={onChangeSelection}
                />
              </div>
              <Button
                label="Firmar"
                disabled={!formRef.current?.values?.docs}
                className={styles.pinButton}
                onClick={SingIn}
              />
            </div>
          );
        }}
      </Formik>
    </div>
  );
};
